var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChademoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8222 30.5096C16.1202 30.5096 18.7937 27.836 18.7937 24.538C18.7937 21.24 16.1202 18.5664 12.8222 18.5664C9.52415 18.5664 6.85059 21.24 6.85059 24.538C6.85059 27.836 9.52415 30.5096 12.8222 30.5096Z",
    stroke: "#183254",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1776 30.5096C38.4756 30.5096 41.1492 27.836 41.1492 24.538C41.1492 21.24 38.4756 18.5664 35.1776 18.5664C31.8796 18.5664 29.2061 21.24 29.2061 24.538C29.2061 27.836 31.8796 30.5096 35.1776 30.5096Z",
    stroke: "#183254",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0844 10.0864C29.0844 13.004 26.7201 15.3684 23.8025 15.3684C20.8849 15.3684 18.5205 13.004 18.5205 10.0864C18.5205 7.16883 20.8849 4.80444 23.8025 4.80444C26.7201 4.80444 29.0844 7.16883 29.0844 10.0864Z",
    stroke: "#183254",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8034 7.29008C24.4898 7.29008 25.0462 6.73365 25.0462 6.04726C25.0462 5.36087 24.4898 4.80444 23.8034 4.80444C23.117 4.80444 22.5605 5.36087 22.5605 6.04726C22.5605 6.73365 23.117 7.29008 23.8034 7.29008Z",
    stroke: "#183254",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8034 15.3911C24.4898 15.3911 25.0462 14.8347 25.0462 14.1483C25.0462 13.4619 24.4898 12.9055 23.8034 12.9055C23.117 12.9055 22.5605 13.4619 22.5605 14.1483C22.5605 14.8347 23.117 15.3911 23.8034 15.3911Z",
    stroke: "#183254",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8493 11.3445C27.1596 11.3445 26.6064 10.7913 26.6064 10.1017C26.6064 9.41209 27.1596 8.85889 27.8493 8.85889C28.5389 8.85889 29.0921 9.41209 29.0921 10.1017C29.0921 10.7837 28.5389 11.3445 27.8493 11.3445Z",
    stroke: "#183254",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7487 11.3445C19.0591 11.3445 18.5059 10.7913 18.5059 10.1017C18.5059 9.41209 19.0591 8.85889 19.7487 8.85889C20.4383 8.85889 20.9915 9.41209 20.9915 10.1017C20.9915 10.7837 20.4383 11.3445 19.7487 11.3445Z",
    stroke: "#183254",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0844 38.4136C29.0844 41.3311 26.7201 43.6955 23.8025 43.6955C20.8849 43.6955 18.5205 41.3311 18.5205 38.4136C18.5205 35.496 20.8849 33.1316 23.8025 33.1316C26.7201 33.1316 29.0844 35.496 29.0844 38.4136Z",
    stroke: "#183254",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8034 35.6172C24.4898 35.6172 25.0462 35.0608 25.0462 34.3744C25.0462 33.688 24.4898 33.1316 23.8034 33.1316C23.117 33.1316 22.5605 33.688 22.5605 34.3744C22.5605 35.0608 23.117 35.6172 23.8034 35.6172Z",
    stroke: "#183254",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8034 43.7183C24.4898 43.7183 25.0462 43.1619 25.0462 42.4755C25.0462 41.7891 24.4898 41.2327 23.8034 41.2327C23.117 41.2327 22.5605 41.7891 22.5605 42.4755C22.5605 43.1619 23.117 43.7183 23.8034 43.7183Z",
    stroke: "#183254",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8493 39.6641C27.1596 39.6641 26.6064 39.1109 26.6064 38.4213C26.6064 37.7317 27.1596 37.1785 27.8493 37.1785C28.5389 37.1785 29.0921 37.7317 29.0921 38.4213C29.0921 39.1109 28.5389 39.6641 27.8493 39.6641Z",
    stroke: "#183254",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7487 39.6641C19.0591 39.6641 18.5059 39.1109 18.5059 38.4213C18.5059 37.7317 19.0591 37.1785 19.7487 37.1785C20.4383 37.1785 20.9915 37.7317 20.9915 38.4213C20.9915 39.1109 20.4383 39.6641 19.7487 39.6641Z",
    stroke: "#183254",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9239 10.0229L42.6579 10.5506L42.9919 11.0382C45.5184 14.7263 46.9927 19.1837 47 24.0015C46.9992 36.7027 36.7014 47 24 47C11.2981 47 1 36.7019 1 24C1 19.3001 2.40852 14.9369 4.82701 11.291L5.14838 10.8065L4.88637 10.2876L3.63628 7.81141L7.02314 4.42454L9.30217 5.57587L9.85146 5.85335L10.3467 5.48804C14.1673 2.66981 18.8865 1 24 1C29.0553 1 33.7229 2.63344 37.5134 5.40009L38.0078 5.76096L38.5541 5.48481L40.6511 4.42469L44.0382 7.81178L42.9239 10.0229Z",
    stroke: "#183254",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChademoSmall);
export default __webpack_public_path__ + "static/media/chademo_small.229957b05e079194c67c06e8c8a5ca8b.svg";
export { ForwardRef as ReactComponent };